import { render, staticRenderFns } from "./articleCard.vue?vue&type=template&id=60f75c6b&scoped=true&lang=pug&"
import script from "./articleCard.vue?vue&type=script&lang=js&"
export * from "./articleCard.vue?vue&type=script&lang=js&"
import style0 from "./articleCard.vue?vue&type=style&index=0&id=60f75c6b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f75c6b",
  null
  
)

export default component.exports